import FocusTimeTooltip, { getName } from "./FocusTimeTooltip";
import React, { useMemo } from "react";
import { PainPoints } from "./PainPoints";
import {
  EventSchedulingQueryAttendee,
  EventSchedulingQueryOrg,
  EventSchedulingQueryPerson,
  PersonImpact,
} from "./EventScheduling";
import { isEmpty } from "lodash";
import classNames from "classnames";
import { ResponseStatusEnum } from "@schema";
import { AvatarPerson } from "@components/avatar/AvatarPerson";
import { getAvatarPerson } from "./EventAttendeesAvatars";

const AttendeeSlotPains = ({
  personImpact,
  person,
  attendee,
  hidePainsForAttendeeWhoHaveDeclined,
}: {
  org: EventSchedulingQueryOrg;
  personImpact: PersonImpact;
  person: EventSchedulingQueryPerson;
  // TODO: (jimmy) we are passing in a nullable attendee in AttendeesSlotPains
  // the props here previously expected a non-null EventSschedulingQueryAttendee
  // but the linter didn't complain
  // -> therefore, fix types?
  attendee: EventSchedulingQueryAttendee | null;
  hidePainsForAttendeeWhoHaveDeclined: boolean;
}) => {
  const { impacts, calendarId } = personImpact;

  const name = getName(person, personImpact);

  // When there only an avatar and a name, make them center to each other
  const shouldRenderAlignCenter =
    !impacts?.hasConflict &&
    isEmpty(impacts?.unavailabilities) &&
    isEmpty(impacts?.inconveniences) &&
    !attendee?.organizer;
  const shouldHidePains =
    hidePainsForAttendeeWhoHaveDeclined && attendee?.responseStatus == ResponseStatusEnum.Declined;

  const avatarPerson = useMemo(() => getAvatarPerson(person, calendarId), [person, calendarId]);

  return (
    <div
      key={calendarId}
      className={classNames("cw-flex cw-flex-row cw-align-bottom cw-mb-2 cw-items-start cw-gap-1", {
        "cw-items-center": shouldRenderAlignCenter,
      })}
    >
      <AvatarPerson
        person={avatarPerson}
        orgPerson={null}
        toolTipContent={<FocusTimeTooltip impacts={impacts} name={name} />}
        backupCalendarId={calendarId}
        size="medium"
        responseStatus={attendee?.responseStatus}
      />
      <div className="cw-text-sm cw-ml-2">
        <div className="cw-max-w-[212px] cw-text-ellipsis cw-overflow-hidden cw-whitespace-nowrap cw-text-standard-grey">
          {name}
        </div>
        {attendee && attendee.organizer && (
          <div className="cw-flex cw-flex-row cw-items-center cw-text-xs cw-text-slate-standard">
            Organizer
          </div>
        )}
        <div className="cw-pt-1 cw-pr-1 cw-text-xs cw-text-slate-standard">
          {impacts && !shouldHidePains && <PainPoints impacts={impacts} />}
        </div>
      </div>
    </div>
  );
};

export default AttendeeSlotPains;
